<button
  class="btn btn-transparent wow animate__animated animate__fadeInUp animate__delay0-5s"
  id="banner-enquiry"
  (click)="book()"
>
  {{ "demo" | translate }}
</button>